import TotemKeyboard from "./TotemKeyboard";

/**
 * Passo em tela cheia do autoatendimento (checkout, busca, comanda): a
 * pergunta em destaque, o conteúdo e os botões presos embaixo.
 */
export function TotemStep({ title, hint, children, footer }) {
  return (
    <div className="totem-step">
      <div className="totem-step__body">
        <h2 className="totem-step__title">{title}</h2>
        {hint && <p className="totem-step__hint">{hint}</p>}
        {children}
      </div>
      {footer && <footer className="totem-step__footer">{footer}</footer>}
    </div>
  );
}

export function BackButton({ onClick }) {
  return (
    <button
      type="button"
      className="totem-btn totem-btn--secondary"
      onClick={onClick}
    >
      Voltar
    </button>
  );
}

/**
 * Passo digitado no teclado da tela: o texto aparece num campo grande, e o
 * erro (se houver) vai no botão de confirmar, que fica desabilitado.
 */
export function KeyboardStep({
  title,
  value,
  placeholder,
  keyboard = "alpha",
  onChange,
  onBack,
  onConfirm,
  disabled,
  error,
  confirmLabel = "Confirmar",
}) {
  return (
    <TotemStep
      title={title}
      footer={
        <>
          <BackButton onClick={onBack} />
          <button
            type="button"
            className="btn btn-shop totem-btn totem-btn--primary"
            disabled={disabled}
            onClick={onConfirm}
          >
            {error || confirmLabel}
          </button>
        </>
      }
    >
      <div className={`totem-step__value${value ? "" : " is-empty"}`}>
        {value || placeholder}
      </div>
      <TotemKeyboard layout={keyboard} onKeyboardChange={onChange} />
    </TotemStep>
  );
}

/**
 * Passo de escolha entre cartões grandes (comer aqui/levar, CPF sim/não).
 * Um toque escolhe e avança.
 */
export function ChoiceStep({ title, options, onBack }) {
  return (
    <TotemStep title={title} footer={<BackButton onClick={onBack} />}>
      <div className="totem-choices">
        {options.map((option) => (
          <button
            key={option.label}
            type="button"
            className="totem-choice"
            onClick={option.onClick}
          >
            <span className="totem-choice__icon">{option.icon}</span>
            <span className="totem-choice__label">{option.label}</span>
          </button>
        ))}
      </div>
    </TotemStep>
  );
}
